import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/mailing";




class EmailService {

 

  addMail(p_email_list : string, p_content : string, p_subject : string){
    return axios
      .post(API_URL + "/addMail", {
            email_list : p_email_list,
            content : p_content,
            subject : p_subject
      })
      .then(response => {
        return response.data;
      });
  }

  addAttachment(p_id : string, p_data : string, p_name : string){
    return axios
      .post(API_URL + "/addAttachment", {
          email_id : p_id, 
          attachment_data : p_data,
          attachment_name : p_name

      })
      .then(response => {
        return response.data;
      });
  }
 
 


  getoutgoingmails(query:string) {
    return axios
      .get(API_URL + "/importedmails?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


  getimportedmails(query:string) {
    return axios
      .get(API_URL + "/outgoingmails?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }



 

}

export default new EmailService();